<div [formGroup]="form" class="page-section card">
  <div class="card-header d-flex justify-content-between align-items-center py-2">
    <label>Buscar acto</label>
    <p-button label="Buscar" [loading]="isSaving" (onClick)="search()" [disabled]="!this.form.valid" />
  </div>

  <div class="card-body d-flex flex-column gap-3">
    <div class="row">
      <div class="col-12 col-lg-6 col-xl-3">
        <div class="mb-3 mb-xl-0 flex flex-column gap-2">
          <p-iftalabel>
            <p-select formControlName="searchBy" [options]="searchByList" class="w-100 h-50px" />
            <label>Búsqueda por</label>
          </p-iftalabel>
        </div>
      </div>

      @if (this.searchBy.value === '1') {
      <div class="col-12 col-lg-6 col-xl-3">
        <div class="mb-3 mb-xl-0 flex flex-column gap-2">
          <p-iftalabel>
            <p-select formControlName="typeActo" [options]="typeActoList" class="w-100 h-50px" />
            <label>Acto Registral</label>
          </p-iftalabel>
        </div>
      </div>

      <div class="col-12 col-lg-6 col-xl-3">
        <div class="mb-3 mb-xl-0 flex flex-column gap-2">
          <p-iftalabel>
            <p-inputMask formControlName="curp" mask="******************" styleClass="w-100 h-50px" />
            <label>CURP</label>
          </p-iftalabel>
        </div>
      </div>
      } @if (this.searchBy.value === '2') {
      <div class="col-12 col-lg-6 col-xl-3">
        <div class="mb-3 mb-xl-0 flex flex-column gap-2">
          <p-iftalabel>
            <p-inputMask formControlName="cadena" mask="99999999999999999999" styleClass="w-100 h-50px" />
            <label>Cadena</label>
          </p-iftalabel>
        </div>
      </div>
      } @if (this.searchBy.value !== null) {
      <div class="col-12 col-lg-6 col-xl-3">
        <div class="mb-3 mb-xl-0 flex flex-column gap-2">
          <p-iftalabel>
            <p-select
              formControlName="folioReverso"
              [options]="[
                { label: 'Sencillo', value: null },
                { label: 'Reverso', value: 'reverso' },
                { label: 'Reverso y folio', value: 'folio_reverso' }
              ]"
              class="w-100 h-50px"
              placeholder="Ninguno"
            />
            <label>Folio, Reverso</label>
          </p-iftalabel>
        </div>
      </div>
      }
    </div>
  </div>
</div>

<div class="page-section card">
  <div class="card-header border-0 py-1"></div>
  <div class="card-body p-0">
    @if (this.isLoading === false) {
    <p-table
      #dt1
      [value]="list"
      dataKey="id"
      [rows]="25"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[25, 50, 100]"
      [paginator]="true"
      [globalFilterFields]="['typeActo', 'curp', 'cadena', 'entidad']"
      paginatorStyleClass="mt-1"
    >
      <ng-template pTemplate="caption">
        <div class="d-flex flex-xl-row gap-2">
          <div class="w-100">
            <p-inputgroup>
              <p-iconfield class="w-100">
                <p-inputicon styleClass="pi pi-search" />
                <input
                  type="text"
                  pInputText
                  [(ngModel)]="searchValue"
                  (input)="dt1.filterGlobal(searchValue, 'contains')"
                  placeholder="Buscar por tipo de acto, dato, entidad."
                  class="w-100 h-50px rounded-end-0"
                />
              </p-iconfield>
              <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>TIPO DE ACTO</th>
          <th>DATO</th>
          <th>ENTIDAD</th>
          <th *showForRoles="['GESTOR']">ROBOT USADO</th>
          <th>ESTATUS</th>
          <th colspan="2">FECHA</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="text-nowrap small">{{ item.id }}</td>
          <td class="text-nowrap small">{{ item.typeActo ?? "..." }}</td>
          <td class="text-nowrap small text-uppercase">{{ item.typeSearch === "1" ? item.curp : item.cadena }}</td>
          <td class="text-nowrap small text-uppercase">{{ item.entidad ?? "..." }}</td>
          <td class="text-nowrap small text-uppercase" *showForRoles="['GESTOR']">{{ item.robotLabel ?? "..." }}</td>
          <td class="text-nowrap small">
            @if (item.error !== null) {
            <p-tag [value]="'Error'" severity="danger" class="fw-normal" (click)="showError(item.error)" />
            } @else {
            <!-- -->
            @if(item.file === null) {
            <p-tag value="Procesando..." severity="secondary" class="fw-normal" />
            } @else {
            <p-tag value="Completo" severity="success" class="fw-normal" />
            }
            <!-- -->
            }
          </td>
          <td class="text-nowrap small">{{ item.dateCreated | date : "longDate" }}</td>
          <td class="text-nowrap small">
            @if (item.error === null && item.file !== null && item.download === 0) {
            <a
              href="{{ apiUrl }}/v1/registro-civil/buscar-acto/download/{{ item.id }}"
              download
              target="_blank"
              rel="noopener noreferrer"
              class="p-button text-decoration-none p-button-success"
              (click)="item.download = 1"
            >
              <i class="pi pi-download"></i>
            </a>
            } @else if (item.error === null && item.file !== null && item.download >= 1) {
            <a href="{{ apiUrl }}/v1/registro-civil/buscar-acto/download/{{ item.id }}" download target="_blank" rel="noopener noreferrer" class="p-button text-decoration-none">
              <i class="pi pi-download"></i>
            </a>
            }
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="8">No se encontraron registros.</td>
        </tr>
      </ng-template>
    </p-table>
    } @else {
    <placeholder-table [header]="['ID', 'TIPO DE ACTO', 'DATO', 'ENTIDAD', 'ROBOT USADO', 'ESTATUS', 'FECHA']" />
    }
  </div>
  <div class="card-footer border-0 py-1"></div>
</div>

<p-dialog
  header="Error"
  [(visible)]="modalVisibleError"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
>
  <div class="text-danger">{{ modalErrorMsg }}</div>
</p-dialog>
